/* eslint-disable no-param-reassign */
import Sonda from '@bit/gerenciatd.utils.front-sonda';
import { createSondaContext } from './contextUtils';


/**
 * Asegura que las imagenes tengan url correcta: si no estas en pro carga la de col10
 * @param {String} url url recibida
 * @returns {String} url formateada
 */
const fixUrlImg = (url) => {
  const urlActual = window.location.href;
  if (urlActual.indexOf('https://www.movistar.es') === -1) {
    return `https://col10mgmt.tsm.inet${url}`;
  }
  return `https://www.movistar.es${url}`;
}

/**
 * Asegura que los precios con parte decimal tenga el formato correcto (separados por '.')
 * @param {String} pvp precio recibido
 * @returns {String} Precio formateado
 */
const fixPVP = (pvp) => {
  const precio = pvp.split(',');
  if (precio.length > 1) {
    return `${precio[0]}.${precio[1]}`;
  }
  return pvp;
}

/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo de explora nuestras soluciones
 * @returns
 * Devuelve la informacion para el modulo de explora nuestras soluciones
 */
export const moduloSolucionesSolucionesDigitales = (fields) => {
  try {
    const newFields = {
      textInfo1: {
        text: fields.title || '',
        size: 'title02',
        kind: 'heading',
        fontType: 'font-light',
        align: 'center',
        level: 2,
        color: 'grey6',
        className: 'title-margin',
        segment: 'emp',
      },
      components: [],
      taggingInfo: {
        componentVariation: 'all',
        componentProduct: '',
      },
    }

    const listItems = fields.soluciones.reduce((arr, item) => {
      const components = {
        title: {
          kind: 'heading',
          level: 4,
          align: 'center',
          size: 'title04',
          fontType: 'font-regular',
          color: 'blue',
          text: item.fields.title || '',
          segment: 'emp',
        },
        text: {
          kind: 'paragraph',
          align: 'center',
          size: 'title045',
          fontType: 'font-light',
          color: 'black',
          text: item.fields.description || '',
          segment: 'emp',
        },
        image: (item.fields.urlImg && `https://www.movistar.es${item.fields.urlImg}`) || '',
        link: (item.fields.urlFicha && `https://www.movistar.es${item.fields.urlFicha}`) || '',
      }
      arr = [...arr, components];
      return arr;
    }, [])

    newFields.components = listItems;
    return newFields;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloSolucionesSolucionesDigitales',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo de banner inferior
 * @returns
 * Devuelve la informacion para el modulo banner inferior
 */
export const moduloBannerInferior = (fields) => {
  try {
    const newFields = {
      taggingInfo: {
        componentPerso: {
          phCode: '',
          promoCode: '',
          prodCode: '',
          levCode: '',
          movCode: '',
          posCode: '',
          defCode: '',
          webCode: '',
          control: 'no-recomendacion',
          userType: 'no-cliente',
          modelType: '',
          recomType: '',
          srvCode: '',
          value: '',
          businessClusters: '',
          versionTest: '',
          fusionComplementAlias: ';',
        },
        componentProduct: ';',
        componentVariation: 'all',
      },
      layout: 'Layout3_Fusion',
      components: {
        'BgImage-1': {
          bgColor: 'black',
          div2Fit: 'full',
          picDesktop: {
            position: 'center',
            size: 'cover',
            src: `https://www.movistar.es${fields.imgDesktop}`,
            shadeLimit: false,
          },
          picTablet: {
            position: 'top',
            size: 'cover',
            src: `https://www.movistar.es${fields.imgDesktop}`,
            shadeLimit: false,
          },
          picMobile: {
            position: 'top',
            size: 'cover',
            src: `https://www.movistar.es${fields.imgDesktop}`,
            shadeLimit: false,
          },
        },
        'TextInfo-1': {
          className: 'title',
          color: 'white',
          kind: 'heading',
          level: 2,
          fontType: 'font-thin',
          align: 'center',
          text: fields.title || '',
          segment: 'emp',
        },
        'TextInfo-2': {
          kind: 'paragraph',
          color: 'white',
          fontType: 'font-regular',
          size: 'title06',
          text: fields.subTitle || '',
          align: 'center',
          segment: 'emp',
          tabletProps: {
            fontType: 'font-light',
            size: 'title05',
          },
          desktopProps: {
            fontType: 'font-light',
            size: 'title05',
          },
        },
        'Button-1': {
          link: fields.urlFicha,
          target: '_blank',
          color: 'blue',
          className: 'upgrade-section__button',
          label: fields.buttom,
          labelSize: 'small',
          buttonType: 'button',
          taggingInfo: {
            componentName: fields.title || '',
            componentVariation: 'all',
            componentContent: fields.buttom || '',
            componentProduct: '',
          },
          size: {
            h: 'regular',
            w: 'full',
          },
          tabletProps: {
            size: {
              w: 'liquid',
            },
          },
          desktopProps: {
            size: {
              w: 'liquid',
            },
          },
          border: 'no-border-radius',
          textTransform: 'initial',
          font: 'bold',
          segment: 'emp',
        },
      },
    }
    return newFields;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloBannerInferior',
      context,
      filePath: 'utils/normalizerModules',
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo de click box
 * @returns
 * Devuelve la informacion para el modulo click box
 */
export const moduloClickBox = (fields) => {
  try {
    const newFields = {
      components: {
        'BgImage-1': {
          picDesktop: {
            position: 'center',
            size: 'cover',
            src: (fields.imgDesktop && fixUrlImg(fields.imgDesktop)) || '',
          },
          picTablet: {
            position: 'top',
            size: 'cover',
            src: (fields.imgDesktop && fixUrlImg(fields.imgDesktop)) || '',
          },
          picMobile: {
            position: 'center',
            size: 'cover',
            src: (fields.imgMobile && fixUrlImg(fields.imgMobile)) || '',
          },
        },
        title: {
          align: 'center',
          color: 'white',
          kind: 'span',
          size: 'title02',
          fontType: 'font-regular',
          text: fields.title || '',
          segment: 'emp',
          tabletProps: {
            size: 'title01',
            align: 'center',
            fontType: 'font-regular',
          },
          desktopProps: {
            align: 'left',
            size: 'title01',
          },
        },
        descripcion: {
          align: 'center',
          kind: 'paragraph',
          color: 'white',
          fontType: 'font-regular',
          size: 'title06',
          segment: 'emp',
          text: fields.subTitle || '',
          tabletProps: {
            size: 'title05',
            align: 'center',
          },
          desktopProps: {
            size: 'title05',
            align: 'left',
          },
        },
        button: {
          label: fields.buttom || '',
          buttonType: 'button',
          color: 'white_blue',
          link: fields.urlFicha || '',
          size: {
            h: 'large',
            w: 'full',
          },
          labelSize: 'medium',
          font: 'regular',
          border: 'no-border-radius',
          tabletProps: {
            size: {
              h: 'large',
              w: 'double',
            },
          },
          segment: 'emp',
        },
      },
    }
    return newFields;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloClickBox',
      context,
      filePath: 'utils/normalizerModules',
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo de venta cruzada
 * @returns
 * Devuelve la informacion para el modulo de venta cruzada
 */
export const moduloVentaCruzada = (fields) => {
  try {
    const newFields = {
      featuredCards: fields.featuredCards || true,
      isSlider: true,
      bgColor: fields.backgroundColor || 'grey1',
      bgImage: fields.backgroundColor ? '' : 'https://www.movistar.es/estaticos/empresas/nuevo-empresas/fd-novedades-empresas-2.jpg',
      direction: 'column',
      segment: 'emp',
      maxSlidesToShow: 4,
      arrowSize: 'small',
      arrowOpacity: 'op-0-6',
      bgColorArrow: 'black',
      colorArrow: 'white',
      taggingInfo: {
        componentContent: fields.alias,
        componentName: fields.name,
        componentProduct: '',
        componentPerso: {
          versionTest: '',
        },
        componentVariation: 'all',
      },
      components: {
        'TextInfo-1': {
          color: fields.colorTitle ||'grey6',
          kind: 'heading',
          fontType: 'font-light',
          align: 'center',
          level: '2',
          size: 'title02',
          text: fields.title,
          desktopProps: {
            size: 'title01',
          },
        },
      },
    };

    if (fields.textButton && fields.linkButton) {
      newFields.components.button = {
        label: fields.textButton || '',
        buttonType: 'button',
        color: 'white_blue',
        link: fields.linkButton ? fixUrlImg(fields.linkButton) : '',
        size: {
          h: 'large',
          w: 'full',
        },
        labelSize: 'medium',
        font: 'regular',
        border: 'no-border-radius',
        tabletProps: {
          size: {
            h: 'large',
            w: 'double',
          },
        },
        segment: 'emp',
      };
    }

    const products = {};
    fields.products.forEach((product, index) => {
      products[`ProductItemCard-${index}`] = {
        segment: 'emp',
        bgColor: product.data.fields.bandaPromo ? 'purple' : 'white',
        productInfoHeight: 'static',
        img: fixUrlImg(product.data.fields.urlImg),
        brandImg: {
          src: product.data.fields.brandImg && product.data.fields.brandImg.url,
          alt: product.data.fields.brandImg && product.data.fields.brandImg.alt,
        },
        components: {
          'TextInfo-1': {
            segment: 'emp',
            color: product.data.fields.bandaPromo ? 'white' : 'blue-dark',
            kind: 'heading',
            level: 3,
            fontType: 'font-bold',
            align: 'left',
            size: 'title06',
            text: product.data.fields.nombreComercial,
          },
          'TextInfo-2': {
            segment: 'emp',
            color: product.data.fields.bandaPromo ? 'white' : 'blue-dark',
            kind: 'paragraph',
            fontType: 'font-regular',
            align: 'left',
            size: 'caption02',
            text: product.data.fields.ctz_claimPrincipal,
          },
          'CustomLink-1': {
            link: fixUrlImg(product.data.fields.urlFicha),
            taggingInfo: {
              componentContent: `emp-home-novedades-${index + 1}`,
              componentName: 'emp-home-novedades',
              componentProduct: product.alias,
              componentPerso: '',
              componentVariation: 'all',
            },
          },
          'Promo-box': {
            bgColor: product.data.fields.bandaPromo
              ? 'purple'
              : product.data.fields.bandaDestacada
                ? 'grey5'
                : 'transparent',
            TextInfo: {
              segment: 'emp',
              color: 'white',
              kind: 'paragraph',
              fontType: 'font-regular',
              align: 'left',
              size: 'caption02',
              text: product.data.fields.bandaPromo || product.data.fields.bandaDestacada,
            },
          },
          'Price-box': {
            textPrice: {
              text: product.data.fields.textPrice ? 'Desde' : '',
              size: 'caption01',
              color: product.data.fields.bandaPromo ? 'orchid-dark' : 'blue-light',
              fontType: 'font-regular',
              segment: 'emp',
            },
            bgColor: product.data.fields.bandaPromo ? 'white' : 'grey8',
            position: 'static',
            prices: [
              {
                segment: 'emp',
                color: product.data.fields.pvpTachado ? 'white' : 'grey8',
                amount: fixPVP(product.data.fields.pvpTachado),
                unity: '€',
                size: 'regular',
                decoration: 'linethrough',
                withSpace: false,
                fontType: 'font-light',
              },
              {
                segment: 'emp',
                color: product.data.fields.bandaPromo ? 'orchid-dark' : 'blue-light',
                amount: fixPVP(product.data.fields.pvp),
                unity: '€/mes',
                size: 'small',
                decoration: 'none',
                withSpace: false,
                fontType: 'font-regular',
              },
            ],
          },
        },
      };
    });
    if (Object.keys(products).length > 0) {
      const newComponents = { ...newFields.components, ...products };
      newFields.components = newComponents;
      return newFields;
    }
    return null;
  } catch (error) {
    const context = createSondaContext('empresas');
    const sonda = new Sonda({
      processName: 'moduloVentaCruzada',
      context,
      filePath: 'utils/soluciones',
    });
    sonda.errorMessage({ error });
    return null;
  }
};